
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Playground, Props, Link } from "docz"
import { DateTime } from "./DateTime"

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "datetime"
    }}>{`DateTime`}</h1>
    <p>{`This React component let you format any date or time based on these criteria:`}</p>
    <ul>
      <li parentName="ul">{`Using strings, Unix timestamp or Date instances as a source`}</li>
      <li parentName="ul">{`Using props to control the formatting`}</li>
      <li parentName="ul">{`Using a Context Provider to have a general formatting configuration`}</li>
      <li parentName="ul">{`Guessing the default browser locale`}</li>
    </ul>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <p>{`Props are matching `}<inlineCode parentName="p">{`Intl.DateTimeFormat`}</inlineCode>{` parameters. So `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat#Parameters"
      }}>{`if you need a detailed explanation for any prop please visit their documentation site`}</a>{`.`}</p>
    <Props of={DateTime} mdxType="Props" />
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <Playground __position={1} __code={'<DateTime>03 dec 1983</DateTime>\n<DateTime\n  locale=\"es-ES\"\n  years=\"numeric\"\n  month=\"short\"\n  day=\"numeric\"\n  hour=\"numeric\"\n  minute=\"numeric\"\n>\n  {new Date(2012, 11, 20, 3, 0, 0)}\n</DateTime>\n<DateTime as=\"span\" month=\"long\" weekday=\"short\" day=\"numeric\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Link,
      DateTime
    }} style={{
      display: "flex",
      justifyContent: "space-around"
    }} mdxType="Playground">
  <DateTime mdxType="DateTime">03 dec 1983</DateTime>
  <DateTime locale="es-ES" years="numeric" month="short" day="numeric" hour="numeric" minute="numeric" mdxType="DateTime">
    {new Date(2012, 11, 20, 3, 0, 0)}
  </DateTime>
  <DateTime as="span" month="long" weekday="short" day="numeric" mdxType="DateTime" />
    </Playground>
    <blockquote>
      <p parentName="blockquote">{`The default value for each date-time component property is undefined, but if all component properties are undefined, then year, month, and day are assumed to be "numeric".`}</p>
    </blockquote>
    <p>{`The recommended way to use this component is within a React Context Provider to set a global config.`}</p>
    <Link to="/recipes" mdxType="Link">Check the Recipes section to see an example</Link>.
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;